const Completed = () => {
  return (
    <div>
      <svg
        width="70"
        height="70"
        viewBox="0 0 70 70"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="35.0389" cy="35.2855" r="34.5193" fill="#9B6BFF" />
        <path
          d="M45.4183 27.1631L30.3161 44.4228L23.8438 37.9504"
          stroke="white"
          strokeWidth="2.87661"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
export default Completed;
